import { render, staticRenderFns } from "./childTable.vue?vue&type=template&id=13ed8bdb&scoped=true&"
import script from "./childTable.vue?vue&type=script&lang=js&"
export * from "./childTable.vue?vue&type=script&lang=js&"
import style0 from "./childTable.vue?vue&type=style&index=0&id=13ed8bdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed8bdb",
  null
  
)

export default component.exports